import React, { useContext } from 'react';
import { Button, Avatar, Typography } from '@mui/material';
import { BiHome, BiSearchAlt } from 'react-icons/bi';
import { BsBookmarks } from 'react-icons/bs'
import { MdOutlinePostAdd } from 'react-icons/md';
import { HiOutlineLogout } from 'react-icons/hi';
import { signOut } from 'firebase/auth';
import { useDispatch } from 'react-redux';
import { AuthContext } from '../../services/AuthContext';
import { authentication } from '../../services';
import { clearData } from '../../redux/actions/recipes';
import { useStyles } from './styles';
import './styles.sass';

const Sidebar = ({ activeScreen, setActiveScreen, setOpen, showRecipe, setShowRecipe }) => {
    const classes = useStyles();
    const { user } = useContext(AuthContext);
    const dispatch = useDispatch();

    const handleInsertion = () => {
        setActiveScreen('add');
        setOpen(true);
    }

    const onSignOut = () => {
        signOut(authentication);
        setTimeout(() => {
            dispatch(clearData());
        }, 500);
    }

    return (
        <div className="sidebar-container">
            <div className="buttons-container">
                <Button
                    disableRipple
                    className={activeScreen === 'main' ? 'button active' : 'button inactive'}
                    startIcon={<BiHome className="icon" />}
                    onClick={() => {
                        setActiveScreen('main');
                        if (showRecipe)
                            setShowRecipe(false);
                    }}
                >
                    {options[0]}
                </Button>
                <Button
                    disableRipple
                    className={activeScreen === 'favorites' ? 'button active' : 'button inactive'}
                    startIcon={<BsBookmarks className="icon" />}
                    onClick={() => {
                        setActiveScreen('favorites');
                        if (showRecipe)
                            setShowRecipe(false);
                    }}
                >
                    {options[1]}
                </Button>
                <Button
                    disableRipple
                    className={activeScreen === 'add' ? 'button active' : 'button inactive'}
                    startIcon={<MdOutlinePostAdd className="icon" />}
                    onClick={handleInsertion}
                >
                    {options[2]}
                </Button>
                <Button
                    disableRipple
                    className={activeScreen === 'search' ? 'button active' : 'button inactive'}
                    startIcon={<BiSearchAlt className="icon" />}
                    onClick={() => {
                        setActiveScreen('search');
                        if (showRecipe)
                            setShowRecipe(false);
                    }}
                >
                    {options[3]}
                </Button>
                <Button
                    disableRipple
                    className="button inactive"
                    startIcon={<HiOutlineLogout className="icon" />}
                    onClick={onSignOut}
                >
                    {options[4]}
                </Button>
            </div>
            <div className="user">
                {user &&
                    <>
                        <Avatar
                            src={user.photoURL}
                            className="avatar"
                        />
                        <Typography
                            variant='subtitle2'
                            className={classes.text}
                        >
                            {user.email}
                        </Typography>
                    </>
                }
            </div>
        </div>
    )
}

const options = [
    'המתכונים שלי',
    'המועדפים שלי',
    'הוספת מתכון',
    'חיפוש מתכון',
    'יציאה מהחשבון'
];

export default Sidebar;